import script from "./OverlayModule.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlayModule.vue?vue&type=script&setup=true&lang=js"

import "./OverlayModule.vue?vue&type=style&index=0&id=67a93e12&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a93e12"]])

export default __exports__